import { RUZUKU_ASSETS_BASE_URL } from 'shared/consts';

export function playNotificationSound() {
  const audio = new Audio(`${RUZUKU_ASSETS_BASE_URL}/pop.mp3`);
  audio.play();
}
